/// <reference path="notificationSetting.module.ts" />
/// <reference path="../../components/common/notificationSetting.service.ts" />
/// <reference path="../../components/commonClasses/commonControllerBase.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.NotificationSetting {
    class NotificationSettingController extends Meevo.Components.CommonClasses.CommonControllerBase {
    // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "$translate",
            "meevo.components.busy.BusyService", "$http"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.HolidayDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: any,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            public $translate: angular.translate.ITranslateService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $http: angular.IHttpService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();
        }

        createContext(): void {
            let vm = this;
            vm.busyService.start();
            vm.securityService.checkSection(vm.meevoSecurityKeys.BUSINESSINFO_NOTIFICATIONS).then(() => {
                vm.busyService.stop();
                vm.context = new NotificationSettingContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, this.$translate, vm.$http);
                super.createContext();
            });
        }

  }

    angular.module("meevo.plugins.notificationSetting")
        .controller("meevo.plugins.notificationSetting.NotificationSettingController", NotificationSettingController);
}